import { FC, ReactElement } from 'react'

import { Link } from 'react-router-dom'

import { Text } from '@shared/components/Text'

import { MenuItem } from '../../constants/MenuItems'
import { useSidebar } from '../../hooks/useSidebar'

type Props = {
  item: MenuItem
}

export const SidebarDesktopMenuItem: FC<Props> = (props): ReactElement => {
  const {
    item: { icon: Icon, ...item },
  } = props

  const { menuSelected } = useSidebar()

  return (
    <li key={item.id}>
      <Link to={item.path} className="hover:bg-background-primary flex items-center gap-2 px-4 py-2 transition-colors">
        <Icon
          data-is-selected={menuSelected === item.id}
          size={16}
          className="text-text-secondary data-[is-selected=true]:text-accent-1"
        />
        <Text
          data-is-selected={menuSelected === item.id}
          className="font-body text-text-secondary data-[is-selected=true]:text-accent-1 text-base"
        >
          {item.name}
        </Text>
      </Link>
    </li>
  )
}
